import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import Dropdown from '../../../components/base/Dropdown/Dropdown';
import { statusClassName, textStatusColorFormatter } from '../../../utils/formatters';
import './dashboard-page.scss';

export default function ExportData(props) {
  const { data } = props;
  const anchorElement = useRef(null);
  const intl = useIntl();
  const { formatMessage } = intl;
  const list = Array.isArray(data) ? data.filter(item => !item.local) : [];

  if (!list.length) {
    return null;
  }

  const getLabel = item => {
    if (item.local) {
      return formatMessage({ id: 'export.local.dir' });
    }
    if (typeof item.uploader_type !== 'undefined') {
      return `${item.name || ''} (${formatMessage({ id: `export.type.${item.uploader_type}` })})`;
    }
    return item.name || item.id || formatMessage({ id: 'export' });
  };

  const getValue = item => {
    const status = Number(item.status);
    if (item.local) {
      return textStatusColorFormatter(formatMessage({ id: `local.folder.status.${status}` }), status);
    }
    return textStatusColorFormatter(formatMessage({ id: 'export.documents' }, { count: item.queue || 0 }), status);
  };

  return (
    <Dropdown
      dropBottom
      usePortal
      className="export-block-wrapper"
      classNamePortal="export-portal"
    >
      <Dropdown.Toggle className="export-toogle">
        <div ref={anchorElement} className="export-block">
          <div className="export-block-text">{formatMessage({ id: 'export' })}</div>
          {list.slice(0, 3).map((item, index) => (
            <div
              key={item.id || index}
              className={classNames('export-block-indicator indicator', `indicator-${index + 1}`, statusClassName(Number(item.status)))}
            />
          ))}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="export-content-wrapper"
        anchorElement={anchorElement}
        classNamePortal="export-portal-menu"
      >
        <div className="export-content">
          <table>
            <tbody>
              {list.map((item, index) => (
                <tr key={item.id || index}>
                  <td className="export-label">{getLabel(item)}</td>
                  <td>{getValue(item)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Dropdown.Menu>
    </Dropdown>

  );
}
